export const DANSKE_BANK_LOAN_VALIDATION_PRODUCT_ID = 'danske-bank-loan-validation';
export const CREATE_ORDER_ADVISOR_STORAGE_KEY_PREFIX = 'teal-business:create-order:selected-advisor';

const normalizeOrganisationValue = (value) => String(value || '').trim().toLowerCase();

export function resolveInitialTargetOrganisationId({ organisationId, availableOrganisations, currentTargetOrganisationId }) {
    const availableIds = (availableOrganisations || []).map(({ organisationId: orgId }) => orgId);

    if (availableIds.includes(currentTargetOrganisationId)) return currentTargetOrganisationId;
    if (availableIds.includes(organisationId)) return organisationId;
    return availableIds[0];
}

export function isDanskeBankOrganisation(organisation) {
    if (!organisation) return false;

    const candidates = typeof organisation === 'string'
        ? [organisation]
        : [organisation.organisationId, organisation.name];

    return candidates
        .map(normalizeOrganisationValue)
        .some((value) => value.includes('danske-bank') || value.includes('danske bank'));
}

export function filterCreateOrderProductOptions({ productOptions, hasUserId }) {
    if (hasUserId) return productOptions || [];

    return (productOptions || []).filter(
        (product) => product?.value !== DANSKE_BANK_LOAN_VALIDATION_PRODUCT_ID,
    );
}

export function filterCreateOrderProductsById({ productsById, hasUserId }) {
    if (hasUserId) return productsById || {};

    const nextProductsById = { ...(productsById || {}) };
    delete nextProductsById[DANSKE_BANK_LOAN_VALIDATION_PRODUCT_ID];
    return nextProductsById;
}

export function hasDanskeBankLoanValidationProduct({ selectedProductIds }) {
    return (selectedProductIds || []).includes(DANSKE_BANK_LOAN_VALIDATION_PRODUCT_ID);
}

export function getCreateOrderAdvisorStorageKey(targetOrganisationId) {
    return `${CREATE_ORDER_ADVISOR_STORAGE_KEY_PREFIX}:${targetOrganisationId || 'unknown'}`;
}

export function getCreateOrderAdvisorId(advisor) {
    return advisor?.id || advisor?.userId || '';
}

export function getCreateOrderAdvisorName(advisor) {
    return advisor?.name || `${advisor?.firstName || ''} ${advisor?.lastName || ''}`.trim();
}

export function buildCreateOrderAssignedAdvisor(advisor) {
    const userId = getCreateOrderAdvisorId(advisor);
    if (!userId) return null;

    const name = getCreateOrderAdvisorName(advisor);

    return {
        userId,
        name,
        email: advisor?.email,
    };
}

const trimOptionalString = (value) => {
    const trimmed = String(value || '').trim();
    return trimmed || undefined;
};

export function buildCreateOrderCustomer(customer) {
    const partner = {
        email: trimOptionalString(customer?.partner?.email),
        cprNr: trimOptionalString(customer?.partner?.cprNr),
        phone: trimOptionalString(customer?.partner?.phone),
    };
    const hasPartnerData = Object.values(partner).some(Boolean);

    return {
        ...customer,
        firstName: trimOptionalString(customer?.firstName) || '',
        lastName: trimOptionalString(customer?.lastName) || '',
        email: trimOptionalString(customer?.email) || '',
        phone: trimOptionalString(customer?.phone),
        cprNr: trimOptionalString(customer?.cprNr),
        bankAssociation: trimOptionalString(customer?.bankAssociation),
        partner: hasPartnerData ? partner : undefined,
    };
}

export function getDefaultSelectedProductIds({ targetOrganisation, productOptions }) {
    if (!isDanskeBankOrganisation(targetOrganisation)) return [];

    const hasDanskeBankLoanValidation = (productOptions || []).some(
        (product) => product?.value === DANSKE_BANK_LOAN_VALIDATION_PRODUCT_ID,
    );

    return hasDanskeBankLoanValidation ? [DANSKE_BANK_LOAN_VALIDATION_PRODUCT_ID] : [];
}

export function requiresCreateOrderFileUpload() {
    return false;
}

export function shouldDisableCreateOrder({ organisationsLoading, organisationsError, targetOrganisationId }) {
    return organisationsLoading || !!organisationsError || !targetOrganisationId;
}
